$(function (ws) {
    ws.views.synnexOverlayView = ws.views.modal.extend({

        /**
         * Initialize the component.
         */
        initialize: function () {
            $('#synnexLogin').show();
            this.$autoRedirectTime = this.$('#autoRedirectTimeOut').val();
            this.$autoRedirectSite = this.$('#autoRedirectTo').val();
            this.$countDownSeconds = this.$('#countDownSeconds');
            this.countdown();
        },

        /**
         * Coundown the seconds to auto redirect
         */
        countdown: function() {
            var duration = moment.duration(parseInt(this.$autoRedirectTime), 'seconds');
            var interval = 1000;

            this.countDownInterval = setInterval(() => {
                duration = moment.duration(duration - interval, 'milliseconds');
                this.$countDownSeconds.html(duration.minutes() + ':' + ('0' + duration.seconds()).slice(-2));
                if (duration.minutes() === 0 && duration.seconds() === 0) {
                    clearInterval(this.countDownInterval);
                    this.$countDownSeconds.html('0:0');
                    window.location.href = this.$('.actions').find('#' + this.$autoRedirectSite + 'Link').children('a').attr('href');
                }
            }, interval);
        }
    });
}(westcon));
